import { TimeSeriesMetric } from '@occc/graphql';
import { parseDate } from '@occc-app/lib/date';

import {
  MINUTES_PER_DAY,
  MINUTES_PER_HOUR,
  DOWNTIME_HIGH_THRESHOLD,
  DOWNTIME_MEDIUM_THRESHOLD,
  SECONDS_PER_DAY,
  SECONDS_PER_MINUTE,
} from './store-downtime-chart.constants';
import { DowntimeMetricPoint } from './store-downtime-chart.types';

export const getDowntimeMetrics = (series: TimeSeriesMetric[]): DowntimeMetricPoint[] => {
  return series
    .map(({ date, value: downtimeInSeconds }) => {
      // We clamp downtimeInSeconds to [0, SECONDS_PER_DAY] so the chart always works
      // with a valid “minutes within a 24‑hour day” value. The API occasionally sends
      // either noisy negatives or totals that exceed one full day
      const clampedSeconds = Math.max(0, Math.min(SECONDS_PER_DAY, downtimeInSeconds));
      const minutes = clampedSeconds / SECONDS_PER_MINUTE;
      const percentage = (clampedSeconds / SECONDS_PER_DAY) * 100;

      let high = 0;
      let medium = 0;
      let low = 0;

      if (percentage > DOWNTIME_HIGH_THRESHOLD) {
        high = minutes;
      } else if (percentage >= DOWNTIME_MEDIUM_THRESHOLD) {
        medium = minutes;
      } else {
        low = minutes;
      }

      return { date: parseDate(date), value: { high, medium, low } };
    })
    .sort((a, b) => a.date.getTime() - b.date.getTime());
};

export const formatDowntimeMinutes = (minutesRaw: number) => {
  const minutes = Math.max(0, Math.min(MINUTES_PER_DAY, Math.round(minutesRaw)));
  const h = Math.floor(minutes / MINUTES_PER_HOUR);
  const m = minutes % MINUTES_PER_HOUR;
  return `${h}h ${m}m`;
};
